import React from 'react'
import { CSSProperties } from 'react'

export const Dot = ({ colour = 'black' }: { colour: CSSProperties['color'] }) => (
  <span className='Dot' style={{ backgroundColor: colour }} />
)
